import {css, cx as addStyles} from '@emotion/css';
import {darken, lighten} from 'polished';
import React, {AnchorHTMLAttributes, ButtonHTMLAttributes, HTMLAttributes} from 'react';
import {theme} from '../Common';
import {Loading} from '../Loading';
import paypal from './paypal.png';

type TagAttributes<T extends React.ElementType> = {
  0: ButtonHTMLAttributes<HTMLButtonElement>;
  1: AnchorHTMLAttributes<HTMLAnchorElement>;
  2: HTMLAttributes<HTMLElement>;
}[T extends 'button' | undefined ? 0 : T extends 'a' ? 1 : 2];

export type PayPalButtonProps<T extends React.ElementType> = {
  loading?: boolean;
  as?: T;
} & TagAttributes<T>;

export const PayPalButton = <T extends React.ElementType>({
  loading,
  className,
  as,
  ...rest
}: PayPalButtonProps<T>) =>
  React.createElement(
    as || 'button',
    {
      className: addStyles(buttonStyle, className),
      ...rest,
    },
    loading ? (
      <Loading width={32} height={32} type='spinningBubbles' color={theme.colors.darkBlue} />
    ) : (
      <img src={paypal} alt='paypal button' />
    ),
  );
const borderRadius = '24px';
const buttonStyle = css({
  width: '194px',
  height: '49px',
  borderRadius,
  background: theme.colors.yellow,
  border: '0',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  outline: 'none',
  transition: 'background 0.1s ease-in-out',
  cursor: 'pointer',
  position: 'relative',
  '&:hover': {background: darken(0.1, theme.colors.yellow)},
  '&:active': {
    background: `transparent linear-gradient(180deg, #ffc438 0%, ${lighten(
      0.1,
      theme.colors.yellow,
    )} 100%) 0% 0% no-repeat padding-box`,
  },
  '&:disabled': {opacity: 0.5, cursor: 'not-allowed'},
});
